var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D92D20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1675_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.8363L8.01018 18.1472L8.0112 18.1493C8.01425 18.4485 8.25801 18.6622 8.53128 18.6602L8.53433 18.6622L12.2558 18.6322C12.5434 18.6302 12.7683 18.3966 12.7647 18.1137L12.754 16.8017L12.5734 16.8027C12.6299 16.2582 13.2914 16.1295 14.609 15.9839L17.7798 15.9575C18.5432 16.0318 19.2826 16.1686 19.336 16.7615L19.2348 16.7625L19.2454 18.0719L19.246 18.0735C19.2485 18.3757 19.4933 18.5885 19.7665 18.5854L19.7696 18.5885L23.4906 18.5569C23.7781 18.5564 24.002 18.3218 24 18.0383L23.9893 16.7279L23.855 16.7289C23.7237 15.932 22.4082 13.359 16.1947 13.3356C9.74498 13.3112 8.23511 15.9809 8.15776 16.8353L8 16.8363Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1675_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.0002,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCallIcon);
export default __webpack_public_path__ + "static/media/end-call-icon.26ce3bea.svg";
export { ForwardRef as ReactComponent };